export default class PdfTemplateText{
    constructor(text){
        this.id = text.id;
        this.x1 = text.x1;
        this.y1 = text.y1;
        this.width = text.width;
        this.height = text.height;
        this.font_size = text.font_size;
        this.bold = text.bold;
        this.italic = text.italic;
        this.text = text.text;
        this.align = text.align;
        this.template_id = text.template_id;
    }

    static getTexts(templateTexts){
        const texts = [];
        templateTexts.forEach(text => {
            texts.push(new PdfTemplateText(text));
        });
        return texts;
    }
}